var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "modals-share-your-design-message-sent",
      "elementType": "div"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "modals-share-your-design-message-sent-title-text",
      "elementType": "h2",
      "text": _vm.translations.shareYourDesignSendMessage
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "modals-share-your-design-message-sent-design-text",
      "elementType": "div"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translations.shareYourDesignSendText) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }